import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsBuyButtonLazy = loadable(
    () => import(/* webpackChunkName: "SettingsLight" */ './SettingsBuyButtonSuspense')
);

export const SettingsBuyButtonAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsBuyButtonLazy />
    </DelayedSuspense>
);
